<!--
 * @Author: Lemon C
 * @Date: 2024-04-29 12:03:34
 * @LastEditTime: 2025-01-15 13:04:30
-->
<template>
    <div class="sup-docs-response-body">
        <span class="body-title">响应体</span>
        <div class="docs-el-table-box">
            <el-table :data="docs_api_data.outputParams" :tree-props="eltable_eltree_props" empty-text="无" row-key="id">
                <el-table-column label="名称" width="230" prop="name"> </el-table-column>
                <el-table-column label="类型" width="120" prop="type"> </el-table-column>
                <!-- <el-table-column label="必填" width="120" prop="require">
                    <template #default="scope">
                        <div>{{ scope.row.require ? '是' : '否' }}</div>
                    </template>
                </el-table-column> -->
                <el-table-column label="描述" prop="description"> </el-table-column>
            </el-table>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref } from 'vue';

const props = defineProps({
    docs_api_data: Object,
});

const eltable_eltree_props = ref({ children: 'subApiParams', hasChildren: 'hasChildren' });
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-docs-response-body {
    position: relative;
    display: flex;
    flex-direction: column;
    text-align: left;

    .body-title {
        position: relative;
        margin-bottom: 18px;
        height: 29px;
        font-weight: 600;
        font-size: 20px;
        color: var(--color-main-text-primary);
        line-height: 29px;
    }

    :deep(.docs-el-table-box) {
        .el-table {
            .el-table__header-wrapper {
                .el-table__cell {
                    font-weight: bold;
                    font-size: 16px;
                    color: var(--color-main-text-primary);
                    line-height: 24px;
                    background-color: var(--color-main-doc-eltree-cell-bg);
                    border-top: 1px solid var(--color-main-border-eltree-gray) !important;
                    border-bottom: 1px solid var(--color-main-border-eltree-gray) !important;
                }
            }

            .el-table__body-wrapper {
                .el-table__row {
                    .el-table__cell {
                        font-weight: 500;
                        font-size: 14px;
                        color: var(--color-main-text-secondary);
                        line-height: 20px;
                        border-bottom: 1px solid var(--color-main-border-eltree-gray) !important;

                        &:nth-child(1) {
                            color: var(--color-main-text-primary);
                        }
                    }
                }
            }

            &::before {
                background-color: var(--color-main-tree-before-bg) !important;
            }
        }
    }
}
</style>
